import * as React from 'react';

import { Icon } from '@gitbook/spine-icons';

import type { DNDItem } from './types';

/**
 * This component is used in conjunction with dnd-kit's DragOverlay to render
 * a summary of what is being dragged, as opposed to dragging the actual items.
 *
 * This approach allows for smoother transitions of items that may unmount while
 * being dragged. Like, virtualized lists or when moving items between different
 * types of containers (e.g. spaces and pages).
 */
export function DragCardPreview(props: { item: DNDItem }): React.ReactElement {
    const { item } = props;

    return (
        <div className="absolute top-0 left-0 flex cursor-grabbing gap-4 whitespace-nowrap rounded bg-primary px-4 py-2 text-[--color-text-primary-text-inside] opacity-drag-preview">
            {item.previewIcon
                ? React.createElement(Icon[item.previewIcon], {
                      className: 'size-4.5',
                  })
                : null}
            <div className="text-ui-action">{item.previewLabel || 'Drop to insert'}</div>
        </div>
    );
}
